import { useLocation, useSearchParams } from 'react-router-dom';

export function useReturnTo() {
    const location = useLocation();
    const [searchParams] = useSearchParams();

    // Prefer explicit state passed during navigate
    const stateReturnTo = (location.state as any)?.returnTo as string | undefined;

    // Fallback: query param
    const queryReturnTo = searchParams.get('returnTo') ?? undefined;

    // Normalize (prevent open redirect issues)
    const normalize = (val?: string) => {
        if (!val) return undefined;
        try {
            // allow only relative app paths
            if (val.startsWith('/') && !val.startsWith('//')) return val;
            if (val.startsWith('../')) return val;
        } catch {
            /* ignore invalid */
        }
        return undefined;
    };

    return normalize(stateReturnTo) ?? normalize(queryReturnTo);
}
